export enum PaginationSortDirection {
  ASC = 'asc',
  DESC = 'desc'
}
